import { TPromoBillingState } from '@r1-frontend/api-domru/spec-offer/v1/spec-offers/dto/ISpecOffer';

import { getDefaultCallback } from '~/src/features/specialOffersContainer/helpers';

export const { DefaultCallback } = getDefaultCallback('onActivate');

export const billingStateMap: { [key: number]: TPromoBillingState } = {
    1344: 'connected',
    1345: 'declined',
    1346: 'viewed',
    1347: 'created',
    1348: 'new',
    1352: 'disconnected',
    2267: 'pending',
};
